export default __webpack_public_path__ + "static/hackathon-grid-8-24c1cf44271606806870b8c9c3634daf.png";